import React from "react";
import { LazyLoadImage } from "../../../../../core/atoms";

import "./aboutExperts.scss";

const imageOne: ISrcSet = {
  default: `https://resources.travellocal.com/about-us/expert-image-one_medium.jpg`,
  srcs: [
    {
      src: `https://resources.travellocal.com/about-us/expert-image-one_medium.jpg`,
      width: 512, // intrinsic width
    },
  ],
};

const imageTwo: ISrcSet = {
  default: `https://resources.travellocal.com/about-us/expert-image-two_medium.jpg`,
  srcs: [
    {
      src: `https://resources.travellocal.com/about-us/expert-image-two_medium.jpg`,
      width: 512, // intrinsic width
    },
  ],
};

const imageThree: ISrcSet = {
  default: `https://resources.travellocal.com/about-us/expert-image-three_medium.jpg`,
  srcs: [
    {
      src: `https://resources.travellocal.com/about-us/expert-image-three_medium.jpg`,
      width: 512, // intrinsic width
    },
  ],
};

export class AboutExperts extends React.Component {
  public render() {
    return (
      <div className="about-experts">
        <div className="about-experts__inner">
          <div className="about-experts__text">
            <header>
              <h2 className="about-experts__title">
                Our local experts
              </h2>
            </header>
            <p>
              We have taken great care in choosing each and every one of our
              local experts. We conduct a thorough vetting process on any local
              company that we feel looks promising before they are put on our
              site. All of them adhere to our ethos, being locally owned and
              committed to providing the best, most immersive holidays.
            </p>
          </div>
          <div className="about-experts__images">
            <div className="about-experts__images-inner">
              <LazyLoadImage
                className="about-experts__image about-experts__image--one"
                src={imageOne}
                alt="Group of TravelLocal experts smiling at the camera"
              />
              <LazyLoadImage
                className="about-experts__image about-experts__image--two"
                src={imageTwo}
                alt="Person on a river in a boat"
              />
              <LazyLoadImage
                className="about-experts__image about-experts__image--three"
                src={imageThree}
                alt="Group of TravelLocal experts waving"
              />
            </div>
            <blockquote className="about-experts__quote">
              &quot;I love introducing travellers to my home country&quot;
              <cite className="about-experts__cite">Poly in Brazil</cite>
            </blockquote>
          </div>
        </div>
      </div>
    );
  }
}
